/* global flatpickr */
'use strict'
const formHelper = {
	el: {
		checkboxes: document.querySelectorAll('.js-checkbox'),
		inputsDate: document.querySelectorAll('.js-datepicker'),
		forms: document.querySelectorAll('.forms-gpf form'),
		body: document.body
	},

	fxFormToJson: function formToJson(elem) {
		let unindexedArray = $(elem).serializeArray()
			, indexedArray = {}
		$.map(unindexedArray, function(n, i) {
			$(n).each(function() {
				n.value === 'true' || n.value === 'false' ? n.value = JSON.parse(n.value) : ''
			})
			indexedArray[n['name']] = n['value']
		})
		return indexedArray
	},

	fxAcceptOnlyNumbers (e) {
		const input = e.currentTarget
		let key = e.charCode ? e.charCode : e.keyCode

		if(key < 48 || key > 57) e.preventDefault()

		if (input.value.length == 1 || input.value.length == 4) {
			input.value = `${input.value}${String.fromCharCode(key)}/`
			e.preventDefault()
		}
	},

	fxShowLoader (form) {
		if ($(form).valid()) {
			$('.spinner-overlay').css('display', 'flex')
			this.el.body.classList.add('no-scroll-hidden')
		}	
	},

	fxRemoveLoader () {
		$('.spinner-overlay').css('display', 'none')
		this.el.body.classList.remove('no-scroll-hidden')
	},

	fxInputEvents() {
		for (const checkbox of this.el.checkboxes)
			checkbox.addEventListener('change', e => e.currentTarget.value = e.currentTarget.checked ? 'true' : 'false')

		for (const input of this.el.inputsDate) {
			// input.addEventListener('keydown', e => {
			// 	let keys = [8, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 229]
			// 	!keys.includes(e.which) ? e.preventDefault() : ''
			// })
			input.addEventListener('keypress', e => {
				this.fxAcceptOnlyNumbers(e)
			})

			//update datpicker DOB endate on input focusout
			input.addEventListener('focusout', e => {
				e.currentTarget.name === 'DriverLicenseDate' && renderDatepicker.fxSetDateOfBirthEndDate(e.currentTarget.value, e.currentTarget, 'DriverLicenseGroup')
			})
		}

		for (const form of this.el.forms) {
			form.addEventListener('submit', e => this.fxShowLoader(e.currentTarget))
		}
	},

	init() {
		this.fxInputEvents()
	}
}

formHelper.init()